<template>
  <div id="app">
    <router-view></router-view>
    <div class="right-bar f-tac" v-if="config.KefuType == 0">
      <div class="bar-list-box">
        <div class="bar-list topbar-box bar-wechat">
          <a>
            <i class="sideBar-animate"></i>扫码领课
            <div class="bar-list-cont">
              <p>
                <span class="right-bar-qrcode" ref="qrCodeUrl"></span>
                <span class="text-gry8a">扫码免费领课</span>
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-xxfa" @click="scroll(1366)">
          <a href="javascript:">学习方案</a>
        </div>
        <div class="bar-list bar-kcst" @click="scrollTo">
          <a href="javascript:">课程试听</a>
        </div>
        <div class="bar-list bar-phone" v-if="config.KefuTelList.length > 0">
          <a href="javascript:">
            电话咨询
            <div class="bar-list-cont">
              <p v-for="(v, i) in config.KefuTelList" :key="i">
                <span>{{ v.KefuName }}：</span>
                {{ v.KefuNumber }}
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-qqq" v-if="config.KefuQQList.length > 0">
          <div>
            QQ咨询
            <div class="bar-list-cont">
              <p v-for="(v, i) in config.KefuQQList" :key="i">
                <a
                  target="_blank"
                  class="service_qq_a"
                  :href="
                    'http://wpa.qq.com/msgrd?v=3&uin=' +
                      v.KefuNumber +
                      '&site=qq&menu=yes'
                  "
                >
                  <img
                    src="https://img2.233.com/wx/union/pc/pupage/img/button_old_171.gif"
                  />
                  <span>{{ v.KefuName }}</span>
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="bar-list bar-app" v-if="config.HasApp">
          <a>
            APP下载
            <div class="bar-list-cont">
              <p>
                <img src="/search/app/markappqrcode" />
                <br />
                <span class="text-gry8a">手机听课更方便</span>
              </p>
            </div>
          </a>
        </div>
        <div class="bar-list bar-app" @click="scroll(99999)">
          <a href="javascript:">常见问题</a>
        </div>
      </div>
      <div @click="scroll(0)" class="bottombar-box bg-gry-f6">
        <i></i>
        <a href="javascript:">回到顶部</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getUnionConfig, GetCookies, Statistics } from "./lib/request.js";
import customerService from "./views/home/cell/customerService";
import Cookies from "js-cookie";
import QRCode from "qrcodejs2";

export default {
  name: "App",
  components: {},
  mixins: [customerService],
  data() {
    return {
      config: {},
    };
  },
  created() {
    if (
      sessionStorage.getItem(window.location.host + "puconfig") == undefined
    ) {
      getUnionConfig({}, (res) => {
        this.config = res.Result;
        sessionStorage.setItem(
          window.location.host + "puconfig",
          JSON.stringify(res.Result || {})
        );
        // this.creatQrCode();
        // if (this.config.IsSenior) {
        //   // window.location.href="/fine/category"+this.$route.path
        // }
        // if (this.config.KefuType == 1) {
        //   var script = document.createElement("script");
        //   script.type = "text/javascript";
        //   try {
        //     script.appendChild(
        //       document.createTextNode(
        //         this.config.KefuCode.replace("<script>", "").replace(
        //           /<\/script>/g,
        //           ""
        //         )
        //       )
        //     );
        //   } catch (ex) {
        //     script.text = this.config.KefuCode;
        //   }
        //   document.body.appendChild(script);
        // }
      });
    } else {
      this.config = JSON.parse(
        sessionStorage.getItem(window.location.host + "puconfig") || "{}"
      );
      // this.creatQrCode();
      // if (this.config.IsSenior) {
      //   // window.location.href="/fine/category"+this.$route.path
      // }
      // if (this.config.KefuType == 1) {
      //   var script = document.createElement("script");
      //   script.type = "text/javascript";
      //   try {
      //     script.appendChild(
      //       document.createTextNode(
      //         this.config.KefuCode.replace("<script>", "").replace(
      //           /<\/script>/g,
      //           ""
      //         )
      //       )
      //     );
      //   } catch (ex) {
      //     script.text = this.config.KefuCode;
      //   }
      //   document.body.appendChild(script);
      // }
    }
  },
  mounted() {
    this.initCnzz();
    if (!Cookies.get("PromoteInfo")) {
      const _location_params = window.location.search.split("?")[1];
      let _promotesign = "";
      _location_params &&
        _location_params.split("&").forEach((item) => {
          item.indexOf("promotesign") > -1 &&
            (_promotesign = item.slice(
              item.indexOf("promotesign") + 12,
              item.length
            ));
        });
      _promotesign &&
        GetCookies({ promotesign: _promotesign }, (res) => {
          const { Result, ResultDescription } = res;
          if (!ResultDescription) {
            const { StaffName, PromoteId } = Result;
            StaffName &&
              PromoteId &&
              Cookies.set(
                "PromoteInfo",
                `StaffName=${StaffName}&PromoteId=${PromoteId}`,
                { expires: 3 }
              );
          }
        });
    }
  },
  methods: {
    initCnzz() {
      Statistics({}, (res) => {
        const { Result } = res;
        window.setUnionCnzzConfig(Result);
      });
      const _script2 = document.createElement("script");
      _script2.type = "text/javascript";
      _script2.src =
        "https://v1.cnzz.com/z_stat.php?id=1279309440&web_id=1279309440";
      document.body.appendChild(_script2);
    },
    creatQrCode() {
      if (this.config.KefuType == 0) {
        setTimeout(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: this.config.PromoteInfo, // 需要转换为二维码的内容
            width: 132,
            height: 132,
            colorDark: "#000",
            colorLight: "#fff",
          });
        }, 1000);
      }
    },
    scrollTo() {
      const htmlScrollTop = document.querySelector("body").scrollTop;
      const scrollDom = document.querySelector(
        htmlScrollTop === 0 ? "html" : "body"
      );
      const mealTop = document
        .querySelector(".bar-xxfa-flag")
        .getBoundingClientRect().top;
      // scrollDom.style.marginTop = -scrollDom.scrollTop + 'px'
      // scrollDom.scrollTop = sssss + lili
      // scrollDom.style.transition = 'all .5s ease-in-out'
      // scrollDom.style.marginTop = sssss + lili
      // setTimeout(() => {
      //   scrollDom.style.transition = 'none'
      // }, 500)
      scrollDom.scrollTop = scrollDom.scrollTop + mealTop;
    },
    scroll(num) {
      document.documentElement.scrollTop = num;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "Microsoft Yahei", "苹方", Helvetica, sans-serif;
}
body {
  background: #fafafa;
  overflow-x: hidden;
}
/*右侧导航*/
.right-bar {
  position: fixed; /*right:4vw;right:20px\9;*/
  /* left: 82%; */
  right: 0;
  top: 50%;
  margin-top: -180px;
  width: 80px;
  z-index: 99;
  text-align: center;
}
.right-bar a {
  text-decoration: none;
}
.right-bar .topbar-box {
  width: 100%;
  height: 74px;
  padding-top: 6px;
  margin-bottom: 6px;
  background: #f64623;
  background: linear-gradient(120deg, #f64623, #fe674a) !important;
  border-radius: 2px 2px 0 0;
}
.right-bar .topbar-box i {
  display: block;
  margin: 6px 24px;
  width: 32px;
  height: 32px;
  background: url("https://img2.233.com/wx/union/pc/pupage/img/ico_bg.png")
    no-repeat 0 -90px;
}
.right-bar .topbar-box a {
  color: #fff;
  font-size: 14px;
}
.right-bar .bottombar-box {
  height: 30px;
  padding: 10px 0;
  background: #f9f9f9;
}
.right-bar .bottombar-box a {
  color: #999;
  font-size: 14px;
}
.right-bar .bottombar-box i {
  display: block;
  margin-left: 30px;
  width: 20px;
  height: 12px;
  background: url("https://img2.233.com/wx/union/pc/pupage/img/ico_bg.png")
    no-repeat -50px -90px;
}
.right-bar .bottombar-box:hover i {
  background-position: -50px -110px;
}

.bar-list {
  position: relative;
}
.bar-list.topbar-box > a {
  background: #f64623;
  background: linear-gradient(120deg, #f64623, #fe674a);
  line-height: 1.2em;
}
.bar-list > a {
  display: block;
  width: 100%;
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  margin-bottom: 1px;
  background: #f9f9f9;
  color: #333;
}
.bar-list > div {
  display: block;
  width: 100%;
  height: 46px;
  line-height: 46px;
  font-size: 14px;
  margin-bottom: 1px;
  background: #f9f9f9;
  color: #333;
  cursor: pointer;
}
.bar-list > div:hover,
.bar-list > a:hover,
.right-bar .bottombar-box:hover {
  background: #f64623;
  background: linear-gradient(120deg, #f64623, #fe674a);
}
.bar-list > div:hover,
.bar-list > a:hover,
.right-bar .bottombar-box:hover a {
  color: #fff;
}

.bar-list-cont {
  position: absolute;
  top: 0;
  right: -600px;
  padding: 10px;
  min-width: 120px;
  border-radius: 2px;
  line-height: 2em;
  transition: width 0.2s ease;
  background: #fff;
  white-space: nowrap;
  box-shadow: 4px 6px 12px rgba(170, 170, 170, 0.1);
  color: #333;
  border: 1px solid #f2f2f2;
}
.bar-list > a:hover .bar-list-cont {
  position: absolute;
  top: 0;
  right: 100px;
}
.bar-list > div:hover .bar-list-cont {
  position: absolute;
  top: 0;
  right: 100px;
}
.bar-list-cont:before {
  content: "";
  position: absolute;
  right: -20px;
  width: 0;
  height: 0;
  border: 10px solid;
  border-color: transparent transparent transparent #fff;
}
.bar-list.bar-wechat img,
.bar-list.bar-app img {
  width: 120px;
  height: 120px;
}
.bar-list-cont p + p {
  margin-top: 6px;
}
.bar-list.bar-qqq .bar-list-cont p:hover {
  color: #f23b3a;
  text-decoration: underline;
}
.bar-list.bar-qqq img {
  vertical-align: middle;
  margin-right: 6px;
  margin-top: -3px;
}

/*跳动动画*/
.sideBar-animate {
  -webkit-animation: two-up-down 0.8s ease infinite 80ms alternate;
  animation: two-up-down 0.8s ease infinite 80ms alternate;
}
@keyframes two-up-down {
  from {
    -webkit-transform: translate(0, 6px);
    transform: translate(0, 6px);
  }
  to {
    -webkit-transform: translate(0, -6px);
    transform: translate(0, -6px);
  }
}

@media screen and (max-width: 1440px) and (min-width: 1000px) {
  .right-bar {
    left: 93%;
  }
}
@media screen and (max-width: 1800px) and (min-width: 1440px) {
  .right-bar {
    left: 88%;
  }
}
/*右侧导航 end*/
</style>
